<div fxLayout="row wrap">
    <div [formGroup]="formGroup" fxFlex.gt-sm="50%" fxFlex.lt-sm="100%">
        <ng-container> <!-- *ngIf="!formGroup?.get(controlName).disabled || !detailMode"-->
            <mat-label class="font-weight-400">{{"INPUT_DATE.SELECT_DATE" | translate}}</mat-label>
            <mat-form-field appearance="outline" floatLabel="always" color="accent" style="width: 100%;">
                <input matInput 
                    [matDatepicker]="dateControl" 
                    [placeholder]="placeholder"
                    [min]="minDate"
                    formControlName="date" [required]="required" (keydown)="handleKeyDown($event)" >
                <mat-datepicker-toggle
                    matSuffix 
                    [for]="dateControl" [disabled]="readonly"> <!-- [disabled]="!formGroup?.get(controlName).enabled" -->
                </mat-datepicker-toggle>                                
                <mat-datepicker #dateControl disabled="false"></mat-datepicker>
                <!-- errors -->
                <!-- <mat-hint *ngIf="getError('required')">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}}</mat-hint>  -->
            </mat-form-field>
        </ng-container>
    
        <!-- <ng-container *ngIf="formGroup.get(controlName).disabled && detailMode">
            <mat-label class="font-weight-400">{{label}}</mat-label>
            <p *ngIf="formGroup.get(controlName).value" style="font-weight: bold;">{{formGroup.get(controlName).value | date: 'dd/MM/yyyy'}}</p>
            <p *ngIf="!formGroup.get(controlName).value" style="font-weight: bold;">{{'-'}}</p>
        </ng-container> -->
    </div>
    
    <div *ngIf="operatorAvailable">
        <div class="m-4 p-8 px-0" fxFlex="100%" fxLayout="row wrap">
            <mat-radio-group (change)="handleQuestionOperator($event)">
                <mat-radio-button class="m-8" value="{{QUESTION_OPERATOR.HigherThan}}" 
                [checked]="QUESTION_OPERATOR.HigherThan === operatorSelected"
                [disabled]="operatorsDisable.includes(QUESTION_OPERATOR.HigherThan)">
                    {{"QUESTION_OPERATOR.HigherThan" | translate}}
                </mat-radio-button><br>
                <mat-radio-button class="m-8" value="{{QUESTION_OPERATOR.LessThan}}"
                [checked]="QUESTION_OPERATOR.LessThan === operatorSelected"
                [disabled]="operatorsDisable.includes(QUESTION_OPERATOR.LessThan)">
                    {{"QUESTION_OPERATOR.LessThan" | translate}}
                </mat-radio-button><br>
                <mat-radio-button class="m-8" value="{{QUESTION_OPERATOR.Equals}}"
                [checked]="QUESTION_OPERATOR.Equals === operatorSelected"
                [disabled]="operatorsDisable.includes(QUESTION_OPERATOR.Equals)">
                    {{"QUESTION_OPERATOR.Equals" | translate}}
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
</div>